// Rodolfo Rivas
// 2017
//*************************************************************//
//                                                             //
//    ╔═╗┌─┐┌┬┐┌─┐┌─┐┌┐┌┌─┐┌┐┌┌┬┐┌─┐  ┬ ┬┌─┐┬ ┬┌─┐┬─┐┬┌─┐      //
//    ║  │ ││││├─┘│ ││││├┤ │││ │ ├┤   │ │└─┐│ │├─┤├┬┘││ │      //
//    ╚═╝└─┘┴ ┴┴  └─┘┘└┘└─┘┘└┘ ┴ └─┘  └─┘└─┘└─┘┴ ┴┴└─┴└─┘      //
//                                                             //
//*************************************************************//


import {Component, NgZone, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import "rxjs/Rx";
import {Location} from "@angular/common";
// ITEM QUE SE DEBE MODIFICAR PARA LOS CRUD
import {Usuario} from "./../recursos/modelo/usuario";
import {UtilConfig} from "../../../../../autenticacion/servicios/UtilConfig";
import {Emisor} from "app/layout/content/seguridad/emisor/recursos/modelo/emisor";
import {Rol} from "../../roles/recursos/modelo/rol";
import {Modulo} from "../../roles/recursos/modelo/modulo";
import {LayoutService} from "../../../../recursos/servicio/layout.service";
import {ConsumerService} from "../../../../recursos/servicio/consumer.service";
import {WebServices} from "../../../../recursos/modelo/consumerModel/web-services.enum";
import {isNullOrUndefined} from "util";

declare const $: any;

declare var swal: any;

interface FileReaderEventTarget extends EventTarget {
    result: string;
}

interface FileReaderEvent extends Event {
    target: FileReaderEventTarget;

    getMessage(): string;
}

@Component({
    moduleId: module.id,
    selector: 'cmp-form-usuario',
    templateUrl: './view/form-usuario.component.html',
    styleUrls: ["./css/form-usuario.component.scss"],
    providers: [ConsumerService]
})
export class FormUsuarioComponent implements OnInit {

//        ╦┌┐┌┬┌┬┐    ┬ ┬  ╔═╗┌─┐┌┐┌┌─┐┌┬┐┬─┐┬ ┬┌─┐┌┬┐┌─┐┬─┐
//        ║││││ │     └┬┘  ║  │ ││││└─┐ │ ├┬┘│ ││   │ │ │├┬┘
//        ╩┘└┘┴ ┴      ┴   ╚═╝└─┘┘└┘└─┘ ┴ ┴└─└─┘└─┘ ┴ └─┘┴└─

    CONST_ORIGEN_LDAP: string;

    // mantener el historial de todo las emisores
    listCustomers: Emisor[];
    emisores: any[];
    roles: Rol[];
    modulos: Modulo[];

    // ITEM DEL CRUD
    // variables de pantalla
    origenCRUD = "Usuario";
    accion = "";
    cargandoList = false;
    cargandoUsuario = false;
    // VARIABLES DE SEGURIDAD
    authorities = {
        ROLE_USUARIO_LISTAR: false,
        ROLE_USUARIO_CONSULTAR: false,
        ROLE_USUARIO_REGISTRAR: false,
        ROLE_USUARIO_MODIFICAR: false,
        ROLE_USUARIO_ELIMINAR: false,
        ROLE_USUARIO_ACTIVAR: false,
        ROLE_VER_PERFIL: false
    };


    URL_BACKEND = "";
    // variables de validaciones del formulario
    form: FormGroup;
    vdl_customer: FormControl;
    vdl_correo: FormControl;
    vdl_username: FormControl;
    vdl_password: FormControl;
    vdl_password_2: FormControl;
    vdl_nombre: FormControl;
    vdl_apellido: FormControl;
    vdl_cedula: FormControl;
    vdl_direccion: FormControl;
    vdl_telefonoPrincipal: FormControl;
    vdl_telefonoSecundario: FormControl;
    vdl_rolesTemplate: FormControl;

    tipoPatalla;

    emisor = new Emisor();

    usuarioSession: Usuario;

    //variables modelo
    ItemSelected = new Usuario();
    empresaAdministradora;

    pdfDocumentTemplates: any = [];
    urlBack;

    constructor(private zone: NgZone,
                private consumer: ConsumerService,
                private route: ActivatedRoute,
                private router: Router,
                private fb: FormBuilder,
                private jwtUtil: UtilConfig,
                private _location: Location,
                private layoutService: LayoutService) {

        this.urlBack = this.jwtUtil.URL_WS_BACKEND;
        this.CONST_ORIGEN_LDAP = jwtUtil.CONST_ORIGEN_LDAP;
        // VERIFICA LOS PERMISOS DEL USUARIO LOGEADO
        this.authorities = jwtUtil.verificarAuthorities(this.authorities);

        this.usuarioSession = jwtUtil.getCurrentUser();
        // SI LA EMPRESA ES ESCON SE HABILITAN LOS SELECT
        if (this.usuarioSession.customer.id.toString() == jwtUtil.ESCON_CUSTOMER) {
            this.empresaAdministradora = true;
            this.ItemSelected.customer = this.usuarioSession.customer;
        } else {
            this.ItemSelected.customer = this.usuarioSession.customer;
        }

        this.emisores = [];
        this.emisores.push({label: 'Seleccione un contribuyente * ', value: null});

        this.roles = [];
        this.roles.push(new Rol(null, 'Seleccione un Templete del Rol *'));


        this.URL_BACKEND = this.jwtUtil.URL_WS_BACKEND;

    }


    ngOnInit() {
        this.consultarCombos();
        this.consultarCombosPdf();
        this.route.url.subscribe(value => {
            if (value[0].toString() == "detallePerfil") {
                this.tipoPatalla = "detallePerfil";
                this.accion = "Modificar";
                this.realizarConsultaUsuario(this.usuarioSession.id);
            } else if (value.length > 0) {
                this.tipoPatalla = "crud";
                this.route.params.subscribe(params => {
                    if (params['id']) {
                        this.realizarConsultaUsuario(params['id']);
                        this.accion = "Modificar";
                    } else {
                        this.accion = "Crear";
                        this.ItemSelected.origen = "SISTEMA";
                    }
                });
            }

        });
        this.createFormControls();
        this.createForm();
    }


//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┌┐┌┌┬┐┌─┐┬  ┬  ┌─┐
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  ├─┘├─┤│││ │ ├─┤│  │  ├─┤
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  ┴  ┴ ┴┘└┘ ┴ ┴ ┴┴─┘┴─┘┴ ┴  


    deshabilitarBoton(): boolean {
        return !this.form.valid;
    }

    AutorizarActualizacion() {
        swal({
            title: '¿Está seguro que desea ' + this.accion + ' el usuario? ',
            text: "El usuario: " + this.ItemSelected.nombres + ", " + this.ItemSelected.apellidos,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, ' + this.accion + '!'
        }).then(() => {
            this.actualizar();
        }, function (dismiss) {
            // dismiss can be 'overlay', 'cancel', 'close', 'esc', 'timer'
            if (dismiss === 'cancel') {
            }
        })
    }


    createFormControls() {
        this.vdl_customer = new FormControl({
                value: "",
                disabled: (!this.empresaAdministradora || (this.usuarioSession.rol.id != 1 && this.usuarioSession.rol.id != -1 && this.usuarioSession.rol.id != 0))
            },
            Validators.required
        );
        this.vdl_correo = new FormControl({value: ""}, [
            Validators.required,
            Validators.email,
            Validators.maxLength(50),

        ]);

        this.vdl_username = new FormControl({value: ""}, [
            Validators.nullValidator,
            Validators.maxLength(8)
        ]);
        this.vdl_nombre = new FormControl({value: ""}, [
            Validators.required,
            Validators.maxLength(20)
        ]);
        this.vdl_apellido = new FormControl({value: ""}, [
            Validators.required,
            Validators.maxLength(20)
        ]);

        this.vdl_password = new FormControl({value: ""}, [
            Validators.nullValidator,
            Validators.maxLength(20)
        ]);

        this.vdl_password_2 = new FormControl({value: ""}, [
            Validators.nullValidator,
        ]);
        this.vdl_cedula = new FormControl({value: ""}, [
            Validators.nullValidator,
            Validators.maxLength(12)
        ]);

        this.vdl_telefonoPrincipal = new FormControl({value: ""}, [
            Validators.nullValidator,
            Validators.maxLength(13)
        ]);

        this.vdl_direccion = new FormControl({value: ""}, [
            Validators.nullValidator,
            Validators.maxLength(250)
        ]);

        this.vdl_telefonoSecundario = new FormControl({value: ""}, [
            Validators.nullValidator,
            Validators.maxLength(13)
        ]);

        this.vdl_rolesTemplate = new FormControl({
            value: "", disabled: (this.tipoPatalla == "detallePerfil")
        }, [
            Validators.required
        ]);


    }


    createForm() {
        this.form = this.fb.group({
            "emisor": this.vdl_customer,
            "username": this.vdl_username,
            "correo": this.vdl_correo,
            "password": this.vdl_password,
            "password_2": this.vdl_password_2,
            "cedula": this.vdl_cedula,
            "nombre": this.vdl_nombre,
            "apellido": this.vdl_apellido,
            "telefonoPrincipal": this.vdl_telefonoPrincipal,
            "telefonoSecundario": this.vdl_telefonoSecundario,
            "direccion": this.vdl_direccion,
            "rolesTemplate": this.vdl_rolesTemplate
        });
    }


    auditoria() {
        $("ul#slide-out").toggleClass("open");
    }


    backClicked() {
        this._location.back();
    }


    avisar() {
        let rol = this.searchRol();
        if (rol != null)
            this.cargarFuncionalidadesUsuario(rol.lstFuncionalidades);
    }

    searchRol() {
        var rol = null;
        $.each(this.roles, (pos, item) => {
            if (item.id == this.ItemSelected.rol.id)
                rol = item;
        });
        return rol;
    }


    cargarFuncionalidadesUsuario(listaFuncionalidades) {

        $.each(this.modulos, (posM, itemM) => {
            $.each(itemM.lstFuncionalidades, (posF, itemF) => {
                itemF.check = false;
            });
        });

        $.each(listaFuncionalidades, (pos, item) => {
            $.each(this.modulos, (posM, itemM) => {
                $.each(itemM.lstFuncionalidades, (posF, itemF) => {
                    if (itemF.id == item.id) {
                        itemF.check = true;
                    }
                });
            });
        });

        $.each(this.modulos, (posM, itemM) => {
            itemM.checkAll = true;
            itemM.checkAny = false;
            $.each(itemM.lstFuncionalidades, (posF, itemF) => {
                if (!itemF.check) {
                    itemM.checkAll = false;
                } else {
                    itemM.checkAny = true;
                }
            });
        });

    }


    verificarFuncionalidad(funcionalidad, modulo) {
        funcionalidad.check = !funcionalidad.check;
        var check = true;
        $.each(modulo.lstFuncionalidades, function (pos, item) {
            if (!item.check)
                check = false;
        });

        modulo.checkAll = check;
    }


    verificarModuloFuncionalidad(modulo) {
        modulo.checkAll = !modulo.checkAll;
        $.each(modulo.lstFuncionalidades, function (pos, item) {
            item.check = modulo.checkAll;
        });
    }

    subirFotoLogo($event) {
        const input = $event.currentTarget;

        if (input.files && input.files[0]) {
            const reader = new FileReader();

            reader.onload = (e: FileReaderEvent) => {
                this.ItemSelected.foto = e.target.result;
            };
            reader.readAsDataURL(input.files[0]);
        }
    }

    verPerfilCustomer() {
        if (this.usuarioSession.rol.id == 2 || this.usuarioSession.rol.id == 1)
            this.router.navigate(['/content', {outlets: {'second': ['perfilCustomer']}}]);
    }


    asignarTemplate(template) {
        this.ItemSelected.pdfDocumentTemplate = template;
    }

//        ╔═╗┬ ┬┌┐┌┌─┐┬┌─┐┌┐┌┌─┐┌─┐  ┌─┐┌─┐┬─┐┬  ┬┬┌─┐┬┌─┐┌─┐ 
//        ╠╣ │ │││││  ││ ││││├┤ └─┐  └─┐├┤ ├┬┘└┐┌┘││  ││ │└─┐ 
//        ╚  └─┘┘└┘└─┘┴└─┘┘└┘└─┘└─┘  └─┘└─┘┴└─ └┘ ┴└─┘┴└─┘└─┘ 


    consultarCombosPdf() {
        // LLAMADO AL SERVICIO
        this.consumer.post(WebServices.URL_GET_COMBOS_EMISOR)
            .subscribe(result => {

                $.each(result["comboPdfDocumentTemplates"], (pos, item) => {
                    this.pdfDocumentTemplates.push(item);
                });

            }, err => {
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar los combos", this.router)
            });
    }

    consultarCombos() {
        // LLAMADO AL SERVICIO
        this.cargandoList = true;
        this.consumer.post<any>(WebServices.URL_GET_COMBOS, {})
            .subscribe(result => {
                this.listCustomers = [];
                $.each((<Array<any>>result["comboCustomers"]), (pos, item) => {
                    if (this.empresaAdministradora && (this.usuarioSession.rol.id == 1 || this.usuarioSession.rol.id != -1 || this.usuarioSession.rol.id != 0)) {
                        this.emisores.push({label: item.value, value: item.key});
                    } else {
                        if (this.usuarioSession.customer.id == item.key) {
                            this.emisores.push({label: item.value, value: item.key});
                        }
                    }
                    this.listCustomers.push(item);
                });

                $.each((<Array<any>>result["roles"]), (pos, item) => {
                    this.roles.push(item);
                });

                this.modulos = [];
                $.each((<Array<Usuario>>result["modulos"]), (pos, item) => {
                    $.each(item.funcionalidades, (posFunc, itemFunc) => {
                        itemFunc.check = false;
                    });
                    item.checkAll = false;
                    this.modulos.push(item);
                });
                this.cargarFuncionalidadesUsuario(this.ItemSelected.rol.lstFuncionalidades);
                this.cargandoList = false;
            }, err => {
                this.cargandoList = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo cargar los combos", this.router)
            });

    }

    actualizar() {
        // LLAMADO AL SERVICIO
        if (this.accion == "Crear" && this.ItemSelected.customer.authenticationType == 'WEB') {
            if (this.form.valid
                && (this.ItemSelected.password == ""
                    || isNullOrUndefined(this.ItemSelected.password))) {
                swal(
                    'Error!',
                    'La clave es obligatoria',
                    'error'
                );
                return false;
            }

            if (this.form.valid
                && (this.ItemSelected.password_2 == ""
                    || isNullOrUndefined(this.ItemSelected.password_2))) {
                swal(
                    'Error!',
                    'La verificación de la clave es obligatoria',
                    'error'
                );
                return false;
            }
        } else {
            if (this.ItemSelected.customer.authenticationType != 'WEB') {
                this.ItemSelected.password = 'Temporal2023#';
                this.ItemSelected.password_2 = 'Temporal2023#';
                this.ItemSelected.username = this.ItemSelected.correo;
            }
        }
        this.cargandoUsuario = true;
        this.ItemSelected.authorities = null;
        this.ItemSelected.rol.authorities = null;
        if (this.ItemSelected.telefonoSecundario == "") {
            this.ItemSelected.telefonoSecundario = null;
        }
        let params = {usuario: this.ItemSelected};
        this.consumer.create(WebServices.URL_ACTUALIZAR, params)
            .subscribe(result => {

                this.ItemSelected.id = result["usuario"].id;
                let usuarioSession = this.jwtUtil.getCurrentUser();
                if (this.ItemSelected.id == usuarioSession.id) {
                    usuarioSession.foto = this.ItemSelected.foto;
                    usuarioSession.nombres = this.ItemSelected.nombres;
                    usuarioSession.apellidos = this.ItemSelected.apellidos;
                    this.jwtUtil.setCurrentUser(usuarioSession);
                    this.layoutService.actualizarSession();
                }

                if (this.accion == "Crear") {
                    swal(
                        'Operación exitosa',
                        'Usuario creado satisfactoriamente.',
                        'success'
                    );
                } else {
                    swal(
                        'Operación exitosa',
                        'Usuario modificado satisfactoriamente.',
                        'success'
                    );
                }

                if (this.tipoPatalla == "detallePerfil") {
                    this.router.navigate(['/content', {outlets: {'second': ['detallePerfil']}}]);
                } else {
                    this.router.navigate(['/content', {outlets: {'second': ['usuario']}}]);
                }
                this.cargandoUsuario = false;
            }, err => {
                this.cargandoUsuario = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo " + this.accion + " el usuario", this.router)
            });
    }

    toggleEstado() {
        if (this.ItemSelected.logEstatusRegistro == 'ACTIVO') {
            this.ItemSelected.logEstatusRegistro = 'INACTIVO';
        } else {
            this.ItemSelected.logEstatusRegistro = 'ACTIVO';
        }
    }

    private realizarConsultaUsuario(id) {
        // LLAMADO AL SERVICIO
        this.cargandoUsuario = true;
        this.consumer.getById<any>("usuario", id, WebServices.URL_GET_USUARIO)
            .subscribe((result) => {
                this.ItemSelected = result["usuario"];
                this.ItemSelected.authorities = null;
                this.ItemSelected.rol.authorities = null;
                let rol = this.searchRol();
                if (rol != null)
                    this.cargarFuncionalidadesUsuario(this.ItemSelected.rol.lstFuncionalidades);
                this.cargandoUsuario = false;
            }, err => {
                this.cargandoUsuario = false;
                this.jwtUtil.abrirModalErrorParaServicios(err, "No se pudo consultar el usuario", this.router)
            });
    }


}



// WEBPACK FOOTER //
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/usuario/cmp-form-usuario/form-usuario.component.ts